import CityPageTemplate from "../city-template/CityPageTemplate";
import { suffolkVaConfig } from "./data";

export default function SuffolkVaPage() {
  return <CityPageTemplate config={suffolkVaConfig} />;
}